export default __webpack_public_path__ + "static/media/vitalik_poap_10.4cfb47fa.svg";